import { Alert, AlertTitle } from "@mui/material";
import { ContentContainer } from "@ssf/components";

export default function ComingSoonPage() {
  return (
    <ContentContainer sx={{ py: 7 }}>
      <Alert severity="info">
        <AlertTitle>En ny klubbsida är på väg</AlertTitle>
        Vi bygger just nu en ny klubbsida för traditionella schackklubbar.
        Arbetet pågår och vi ser fram emot att välkomna dig hit när sidan är
        redo!
      </Alert>
    </ContentContainer>
  );
}
